/**
 * @author wuTao
 * @description 课堂助手-直播课堂、远程评估查看
 * @Date 2020/12/25
 */
import React from 'react';
import { connect } from 'dva';
import { reduxTemplateCofig, templateConfig } from './columns'
import OrgRemoteEvaluation from './orgRemoteEvaluationInfo'
import { modelUtils } from '@/utils'
import { component_tool, framework_tool, utils_tool } from '@/tool'
//import {classStudentLiveRecordExcelColumns} from '../../excelColumns';
import moment from "moment";

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal } = component_tool;
let { Session } = utils_tool;
const getOrgRemoteEvaluation = (history) => {
  let record = {}
  if (history.location) {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('orgRemoteEvaluation', record)
    } else {
      record = Session.get('orgRemoteEvaluation') || 0
    }
  } else {
    record = Session.get('orgRemoteEvaluation') || 0
  }
  return record
}

const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH.mm.ss') : '';
}
class OrgRemoteEvaluationInteractLiveList extends WizContainer {
  componentName = 'orgRemoteEvaluationInteractLiveList';
  constructor(props) {
    super(props);
    this.state = {
      selectedClassResultRows: [],//选择的学员
      classStudentExamInfo: {}
    };
    this.orgRemoteEvaluation = getOrgRemoteEvaluation(props.history);
  }

  propsAndStateOnChange = {

  };



  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      if (o['data'] != null) {
        wizNotice.success(o['msg'])
      } else {
        wizNotice.success(o['msg'])
      }
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columns = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职',
        field: 'jobName',
        width: 60,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobState',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否参加',
        field: 'attend',
        width: 12,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
     
      {
        headerName: '进入时间',
        field: 'startTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '离开时间',
        field: 'endTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '累计观看时长(分钟)',
        field: 'durationMinute',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '累计进入次数',
        field: 'countNumber',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ];
    if (o['success']) {
      let data = o['data'];
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState === 1 ? "在职" : d.jobState === 0 ? "离职" : "";
        _d.attend = d.attend === 1 ? "是" : d.isAttend === 0 ? "否" : "";
        _d.startTime = d.startTime ? formatterDateTime(d.startTime) : "";
        _d.endTime = d.endTime ? formatterDateTime(d.endTime) : "";
        _d.duration = d.duration ? d.duration : "";
        _data.push(_d);
      });
      //title
      let record = Session.get('orgRemoteEvaluation');
      let title = record ? '检核场次: '+ record['name']
         +'\n'+ '检核项目: '+ record['remoteAuthName'] 
         +'\n'+ '检核时间: '+ record['startToEndDateStr']
         +'\n'+ '经销商简称: '+ record['shortName']
         +'\n'+ '经销商代码: '+ record['dealerNumber'] : '';
      WizBrowserExport({
        title: title ,// '参训记录信息',
        sheetName: '参训记录信息',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '参训记录信息.xlsx',
        titleParams: {
          alignment: {vertical: 'bottom', horizontal: 'left', wrapText: true},
          style: {
            alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
          },
          font: {},
        },
        titleRow: {
          height: 70
        }
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    const { orgRemoteAuthDetailLoading } = this.props;
    let record = this.orgRemoteEvaluation;
    let name = null;
    let remoteAuthName = null;
    let startToEndDateStr = null;
    let id = null;
    let interactLiveId = null;
    if (record) {
      name = record.name;
      remoteAuthName = record.remoteAuthName;
      startToEndDateStr = record.startToEndDateStr;
      id = record.id;
      interactLiveId = record.interactLiveId;
    }
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      name,
      remoteAuthName,
      startToEndDateStr,
      interactLiveId
    });
    let _reduxTemplateConfig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      id,
      interactLiveId,
      apiDataFormat: {
        exportClassStudentInteractLive: this._handleFile,
        syncLiveRecord: this._handleCMD,
      },
    });

    return (
      <>
        <WizSpin tip={"加载中"} spinning={orgRemoteAuthDetailLoading}>
          <OrgRemoteEvaluation {...record} />
          <WizCard title={'参训记录'}>
            <WizReduxTemplate  {..._reduxTemplateConfig} />
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { orgRemoteAuthDetail } = state;
  const load = modelUtils.getLoadingState(state, ['orgRemoteAuthDetail']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(OrgRemoteEvaluationInteractLiveList);
